import React, { useContext } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { BaseTable } from '../BaseTable/BaseTable';
import { usedPromoCodesColumns } from './user.constant';
import { useParams } from 'react-router-dom';
import { Context } from 'src/context';

const UsedPromoCodesPanel = ({ isReadOnly = false, data }) => {
  const { id } = useParams();
  const { timezone } = useContext(Context);

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, color: '#212B36' }}>
        Promo Codes Used by Customer
      </Typography>
      <BaseTable
        rows={data || []}
        columns={usedPromoCodesColumns(isReadOnly, id, timezone.timezone?.value)}
        loading={false}
        getRowId={(row) => row?.promo_code_audit_id}
        pageSize={10}
        pagination={true}
        sx={{
          '& .MuiDataGrid-root': {
            border: '1px solid rgba(145, 158, 171, 0.12)',
            borderRadius: 1,
          }
        }}
      />
    </Box>
  );
};

export default UsedPromoCodesPanel;
